<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Mobile Instruction Component Input</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" id="modal-body">
    <div class="overflow-table-display">
        <!-- {{mobileInstruction.mobileComponentInput}} -->
        <ngx-codemirror #codemirror name="testdata-value" class="javascript-editor" [(ngModel)]="mobileInstruction.mobileComponentInput" [ngModelOptions]="{ standalone: true }" [options]="codeMirrorOptions"></ngx-codemirror>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-warning btn-sm" type="button" (click)="close()">Cancel</button>
</div>